module.exports = __webpack_public_path__ + "img/hic-cervical-cancer-female.ea4d3561.png";